import React from 'react';

import Typography from '../../../../../typography/typography';

import './fitment-no-results-found.scss';

interface FitmentNoResultsFoundProps {
  onClick: () => void;
}

function FitmentNoResultsFound(props: FitmentNoResultsFoundProps) {
  const { onClick } = props;

  return (
    <Typography onClick={onClick} styleName="custom" tag="button">
      I can`t find it
    </Typography>
  );
}

export default FitmentNoResultsFound;
